import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { isEditActiveSelector } from "../../../reducers/editReducer";
import { Dimmer } from "semantic-ui-react";
import Table from "../../../components/Table/Table";
import { setGroupAPMParameterExtraProperties } from "../../../utils/pdApiUtils";
import { EditActions, editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import { mainActions, MainActions } from "../../../actions/mainActions";
import _ from "lodash";
import APMParameters from "./APMParameters";
import { getDependentGroupParametersColumns } from "../../../reducers/parameterTableConfig";

/**
 * All the following props are passed from parent component
 */

type StateProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  subMenuRoute: State.APMSubmenu;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.APMSubmenu, columnFilter: Filter[]) => void;
  isLoadingApmParameters: boolean;
};

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
};

type OwnProps = {
  toggleModal: () => void;
  isLoading?: boolean;
};

export type APMParametersTableProps = StateProps & DispatchProps & OwnProps;

type APMParametersTableState = {
  isModalOpen: boolean;
};

export class APMParametersTable extends React.Component<
  APMParametersTableProps,
  APMParametersTableState
> {
  state = {
    isModalOpen: false
  };

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }

  render(): JSX.Element {
    const {
      columns,
      pdApi,
      mainState,
      isEditActive,
      toggleModal,
      isLoadingApmParameters
    } = this.props;
    const { apmParameters } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    let parameterRows: Api.AnyParameter[] = [];
    let selectedColumns: State.Column[] = [];

    parameterRows = apmParameters ? apmParameters : [];
    parameterRows = parameterRows.map(row =>
      setGroupAPMParameterExtraProperties(row as Api.ApmParamters, pdApi)
    );
    selectedColumns = columns["APM Parameters"];
    const startingPage = mainState.lastEditedObjectId
      ? (parameterRows.findIndex(parameter => parameter.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;
    if (apmParameters) {
      const featureDbIds: number[] = apmParameters.map(param => param.featureDbId);
      const featureOptions: string[] = _.uniq(featureDbIds.map(id => pdApi.features[id].swName));

      selectedColumns = getDependentGroupParametersColumns(
        columns["APM Parameters"],
        featureOptions
      );
    }
    // Add submenu specific columns and rows
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={parameterRows}
            loading={isLoadingApmParameters}
            loadingText="Fetching APM parameters"
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isParameterSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div
              className="edit-view"
              style={{ flex: editSize, width: editSize == 0.3 ? "500px" : "1000px" }}
            >
              <APMParameters groupName="APM" toggleModal={toggleModal} columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }
  /**
   * Returns status if parameter has been selected
   * @param {Api.AnyParameter} fault
   * @returns {boolean}
   */
  private isParameterSelected = (parameter: Api.AnyParameter): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && parameter.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

const mapStateToProps = (state: State.Root) => ({
  columns: state.columns,
  mainState: state.main,
  isEditActive: isEditActiveSelector(state.editView),
  isLoadingApmParameters: state.loadingStatus.isLoadingApmParameters
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions | MainActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch),
  mainActions: bindActionCreators({ ...mainActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(APMParametersTable);
